import { useNavigate } from "@usas/ui-web/wrappers/ReactRouterDom";
import useNavRoutes from "@usas/ui-web/state/security/UseNavRoutes";

const useMergeButton = () => {
  const navigate = useNavigate();
  const { navRoutes } = useNavRoutes();

  const onClick = (e) => {
    e?.preventDefault();

    navigate(navRoutes.MEMBER_MERGE_SEARCH?.route);
  };
  
  return {
    onClick
  };
};

export default useMergeButton;